module.exports = __webpack_public_path__ + "img/icon-package@2x.e6808d60.png";